
import ajax from '@/utils/ajax';

export default {
  common: {
    login: '/login',
    tianqi: '/tianqi',
    getMenuList: '/menu/getUserMenus',
    getMenuListData: '/api/autobio/navigation',
    getDict: '/api/oec/BasicData/get',
    getAuth: '/api/abp/application-configuration',
    getUserInfo: 'api/oec/UserInfo/getUser',
    addpwd:'api/autobio/users/addpwd',
    changepwd:'api/autobio/users/changepwd',
    removepwd:"/api/autobio/users/removepwd",
    getAccExportColumn: '/api/oec/Common/GetMngExtFomAcColumn',
    initial: '/api/oec/Common/GetIsInitial',
    recommendDeclareMenuTag: '/api/oec/OecRecommend/GetMenuTag',
    getYearPlanConfig: '/api/oec/Common/GetYearPlanConfig',
    getPersonalOECAndRecommend: '/api/oec/Common/GetPersonalOECandRecomm',
    getSubHalfYearWorkCompleteList: '/api/oec/UserInfo/GetSubHalfYearWorkCompleteList',
  },
  home: {
    common: {
      list: '/api/oec/MsCommonFuntion/list',
      add: '/api/oec/MsCommonFuntion/Create',
      update: '/api/oec/MsCommonFuntion/Update',
      delete: '/api/oec/MsCommonFuntion',
      readMe: "/api/oec/Common/GetReadMe",
    },
    work: {
      list: 'api/oec/Home/list',
      createModify: 'api/oec/WorkitemModify/Create',
    },
  },
  notice: {
    list: '/api/oec/MsgNotification/list',
    handle: '/api/oec/MsgNotification',
    delete: '/api/oec/MsgNotification/DeleteMany',
    count: '/api/oec/MsgNotification/MsgCount',
  },
  WorkitemModify: {
    list: '/api/oec/WorkitemModify/GetInfoById',
    update: '/api/oec/WorkitemModify/Update',
  },
  week: {
    weekWork: {
      list: '/api/oec/WeekWork/list',
      add: '/api/oec/WeekWork',
      patch: '/api/oec/WeekWork/Patch'
    },
    WeekWorkDetail: {
      list: '/api/oec/WeekWorkDetail/list',
      detail: '/api/oec/WeekWorkDetail',
      addAll: '/api/oec/WeekWorkDetail/CreateMany',
      submit: '/api/oec/WeekWorkDetail/CommitWorkItem',
      updateAllStatus: '/api/oec/WeekWorkDetail/UpdateAllStatus',
      updateStatus: '/api/oec/WeekWorkDetail/UpdateStatus',
      commitComplete: '/api/oec/WeekWorkDetail/CommitComplete',
      updateWorkClassify: '/api/oec/WeekWorkDetail/UpdateWorkClassify',
      release: '/api/oec/WeekWorkDetail/release-by-id',
      history: '/api/oec/WeekWorkDetail/history-by-id',
      export: '/api/oec/Export/WeekWorkDetailExport',
      last: '/api/oec/WeekWorkDetail/list-last-by-id',
      updateMany: '/api/oec/WeekWorkDetail/UpdateMany2',
      pre: '/api/oec/WeekWorkDetail/pre-by-id',
      Import: '/api/oec/WeekWorkDetail/Import',
    },
  },
  month: {
    monthWork: {
      list: '/api/oec/MonthWork/list',
      add: '/api/oec/MonthWork',
      patch: '/api/oec/MonthWork/Patch'
    },
    MonthWorkDetail: {
      list: '/api/oec/MonthWorkDetail/list',
      detail: '/api/oec/MonthWorkDetail',
      addAll: '/api/oec/MonthWorkDetail/CreateMany',
      submit: '/api/oec/MonthWorkDetail/CommitWorkItem',
      updateAllStatus: '/api/oec/MonthWorkDetail/UpdateAllStatus',
      updateStatus: '/api/oec/MonthWorkDetail/UpdateStatus',
      commitComplete: '/api/oec/MonthWorkDetail/CommitComplete',
      updateWorkClassify: '/api/oec/MonthWorkDetail/UpdateWorkClassify',
      release: '/api/oec/MonthWorkDetail/release-by-id',
      history: '/api/oec/MonthWorkDetail/history-by-id',
      export: '/api/oec/Export/MonthWorkDetailExport',
      last: '/api/oec/MonthWorkDetail/list-last-by-id',
      Import: '/api/oec/MonthWorkDetail/Import',
      updateMany: '/api/oec/MonthWorkDetail/UpdateMany2',
      pre: '/api/oec/MonthWorkDetail/pre-by-id'
    },
  },
  day: {
    dayWork: {
      list: '/api/oec/DayWork/list',
      add: '/api/oec/DayWork',
      reply: '/api/oec/DayWork/ReplyCommit',
      selfEvaluation: '/api/oec/DayWork/SelfEvaluation',
    },
    DayWorkDetail: {
      list: '/api/oec/DayWorkDetail/list',
      detail: '/api/oec/DayWorkDetail',
      createPlan: '/api/oec/DayWorkDetail/CreatePlan',
      deletePlan: '/api/oec/DayWorkDetail/delete-plan',
      addAll: '/api/oec/DayWorkDetail/CreateAll',
      submit: '/api/oec/DayWorkDetail/CommitWorkItem',
      updateWorkClassify: '/api/oec/DayWorkDetail/UpdateWorkClassify',
      export: '/api/oec/Export/DayWorkDetailExport',
    },
  },
  sys: {
    user: {
      list: '/user/list',
      add: '/user/add',
      update: '/user/update',
      delete: '/user/delete',
      getUserRole: '/user/getUserRole',
      updateUserRole: '/user/updateUserRole',
    },
    menu: {
      list: '/menu/getAll',
      add: '/menu/add',
      update: '/menu/update',
      delete: '/menu/delete',
    },
    role: {
      list: '/role/list',
      add: '/role/add',
      update: '/role/update',
      delete: '/role/delete',
      getAll: '/role/getAll',
      getRoleMenu: '/role/getRoleMenu',
      updateRoleMenu: '/role/updateRoleMenu',
    },
    userInfo: {
      list: '/api/autobio/users/list',
      downList: '/api/oec/Common/GetUserList',
      getUserFilter: 'api/oec/Common/GetUserListForSysFilterAsync',
    },
    users: {
      list: '/api/oec/UserInfo/list',
      adu: '/api/oec/UserInfo',
      exportUser: '/api/oec/UserInfo/UserInfoImport',
      clearCache: '/api/oec/UserInfo/ClearCache',
      resetPwd: '/api/oec/UserInfo/ResetPWD',
    },
  },
  example: {
    lodop: {
      list: '/template/list',
      add: '/template/add',
      update: '/template/update',
      delete: '/template/delete',
    },
  },
  Identity: {
    Users: {
      list: '/api/autobio/users',
      updateUserPermissionGroups:'/api/oec/UserInfo/UpdateUserPermissionGroups'
    },
    Groups: {
      list: '/api/autobio/permissiongroup',
      auth: '/api/permission-management/permissions',
      updateAuth: '/api/oec/UserInfo/UpdatePermision',

      dataGrants: '/api/oec/DataGrants',
      users: '/api/oec/UserInfo/GetSysInfoByPermissionGroupId',
      updateUsers: '/api/oec/UserInfo/AddSysInfoPermissionGroup',

      mngGroups: '/api/oec/ManagerPermissionGroups/GetSysInfoByPermissionGroupId',
      updateMngGroups: '/api/oec/ManagerPermissionGroups/AddSysInfoPermissionGroup',

      updateInfo: '/api/oec/Common/UploadReadMe',
    },
    Categord: {
      list: '/api/oec/MsWorkItemCategord/list',
      create: '/api/oec/MsWorkItemCategord/Create',
      update: '/api/oec/MsWorkItemCategord/Update',
      delete: '/api/oec/MsWorkItemCategord',
      dep: '/api/oec/MsWorkItemCategord/listDisplayName',
      categoryByNo: '/api/oec/MsWorkItemCategord/listByUserId',
    },
    MsgSetting: {
      all: '/api/oec/MsgNotificationSetting/listSystemNotification',
    },
    MsgUser: {
      all: '/api/oec/MsgUser/GetInfoByWkno',
      save: '/api/oec/MsgUser/Save',
    },
    MsgNotificationSetting: {
      list: '/api/oec/MsgNotificationSetting/list',
      adu: '/api/oec/MsgNotificationSetting',
    },
    BasicData: {
      list: '/api/oec/BasicData/list',
      all: '/api/oec/BasicData/get',
      adu: '/api/oec/BasicData',
    },
    Settings: {
      list: '/api/oec/Settings/list',
      adu: '/api/oec/Settings',
    },
    CustomSetting: {
      list: '/api/oec/CustomSetting/List',
      allList: '/api/oec/CustomSetting/GetAllList',
      create: '/api/oec/CustomSetting/Create',
      update: '/api/oec/CustomSetting/Update',
      base: '/api/oec/CustomSetting',
    },
    deptNotification: {
      list: '/api/oec/DeptNotification/List',
      create: '/api/oec/DeptNotification/Create',
      delete: '/api/oec/DeptNotification/Delete',
      exportFile: '/api/oec/Export/GetDeptNotificationByte',
      update: '/api/oec/DeptNotification/Update',
      noticeDeptExeList: '/api/oec/UserInfo/GetDeptList',
      noticeDeptHalfList: '/api/oec/UserInfo/GetDeptHalfList',
      exportFileExeNotice: '/api/oec/Export/GetDeptListInfoByte',
      exportFileHalfNotice: '/api/oec/Export/GetDeptHalfListInfoByte',
      importFile: '/api/oec/DeptNotification/Import',
      
    },
  },
  year: {
    yearWork: {
      list: '/api/oec/YearPlan/list',
      adu: '/api/oec/YearPlan',
    },
    yearWorkDetail: {
      list: '/api/oec/yearPlanDetail/list',
      adu: '/api/oec/YearPlanDetail',
      submit: '/api/oec/YearPlanDetail/CommitWorkItem',
      updateAllStatus: '/api/oec/YearPlanDetail/UpdateAllStatus',
      updateStatus: '/api/oec/YearPlanDetail/UpdateStatus',
      UpdateWorkClassify: '/api/oec/YearPlanDetail/UpdateWorkClassify',
      Import: '/api/oec/YearPlanDetail/Import',
      importNext: '/api/oec/YearPlanDetail/ImportForDynamic',
      updateSummary: '/api/oec/YearPlanDetail/UpdateSummary',
      updateMany: '/api/oec/YearPlanDetail/UpdateMany',
      exportNext: '/api/oec/Export/TbYearPlanDetailExportForDynamic',
    },
  },
  add: {
    year: {
      yearWork: {
        list: '/api/oec/AddYearPlan/list',
        adu: '/api/oec/AddYearPlan',
      },
      yearWorkDetail: {
        list: '/api/oec/AddYearPlanDetail/list',
        adu: '/api/oec/AddYearPlanDetail',
        submit: '/api/oec/AddYearPlanDetail/CommitWorkItem',
        updateStatus: '/api/oec/AddYearPlanDetail/UpdateStatus',
      },
    },
    month: {
      monthWork: {
        list: '/api/oec/AddMonthWork/list',
        adu: '/api/oec/AddMonthWork',
      },
      monthWorkDetail: {
        list: '/api/oec/AddMonthWorkDetail/list',
        adu: '/api/oec/AddMonthWorkDetail',
        submit: '/api/oec/AddMonthWorkDetail/CommitWorkItem',
        updateStatus: '/api/oec/AddMonthWorkDetail/UpdateStatus',
      },
    },
    week: {
      weekWork: {
        list: '/api/oec/AddWeekWork/list',
        adu: '/api/oec/AddWeekWork',
      },
      weekWorkDetail: {
        list: '/api/oec/AddWeekWorkDetail/list',
        adu: '/api/oec/AddWeekWorkDetail',
        submit: '/api/oec/AddWeekWorkDetail/CommitWorkItem',
        updateStatus: '/api/oec/AddWeekWorkDetail/UpdateStatus',
      },
    },
    released: {
      allWorkList: '/api/oec/AddedWork/AllWorkList',
      yearPlanList: '/api/oec/AddedWork/YearPlanlist',
      monthPlanList: '/api/oec/AddedWork/MonthWorklist',
      weekPlanList: '/api/oec/AddedWork/WeekWorklist',
      remind: '/api/oec/AddedWork/Remind',
      detailList: '/api/oec/AddedWork/GetWorkList',
      detailListByGroup: '/api/oec/AddedWork/GetWorkListByGroup',
      yearDetailList: '/api/oec/AddedWork/GetYearWorkList',
      yearDetailListByGroup: '/api/oec/AddedWork/GetYearWorkListByGroup',
      getTransferAndHandOverList: '/api/oec/AddedWork/GetTransferAndHandOverList',
    },
    PublishMonthWork: {
      list: '/api/oec/PublishMonthWork/list',
      adu: '/api/oec/PublishMonthWork',
      saveAndRelease: '/api/oec/PublishMonthWork/CreateCommitWorkItemAsync',
      commitWorkItemBatch: '/api/oec/PublishMonthWork/CommitWorkItem',
      commitWorkItem: '/api/oec/PublishMonthWork/CommitWorkItemOrigin',
      updateStatus: '/api/oec/PublishMonthWork/UpdateStatus',
      
      batchAdd: '/api/oec/PublishMonthWork/CreateBatch',
      batchSaveAndRelease: '/api/oec/PublishMonthWork/CreateCommitWorkItemBatch',
    },
    PublishYearWork: {
      list: '/api/oec/PublishYearWork/list',
      adu: '/api/oec/PublishYearWork',
      saveAndRelease: '/api/oec/PublishYearWork/CreateCommitWorkItemAsync',
      commitWorkItemBatch: '/api/oec/PublishYearWork/CommitWorkItem',
      commitWorkItem: '/api/oec/PublishYearWork/CommitWorkItemOrigin',
      updateStatus: '/api/oec/PublishYearWork/UpdateStatus',

      batchAdd: '/api/oec/PublishYearWork/CreateBatch',
      batchSaveAndRelease: '/api/oec/PublishYearWork/CreateCommitWorkItemBatch',
    },
  },
  manage: {
    declare: {
      list: '/api/oec/Declare/list',
      history: '/api/oec/Declare/history-list',
      create: '/api/oec/Declare/CreateOrUpdate',
      createAll: '/api/oec/Declare/CreateOrUpdateMany',
      submit: '/api/oec/Declare/commit',
      analyze: '/api/oec/Declare/analyze',
      analyzeDefault: '/api/oec/Declare/analyzeDefault',
      oec: '/api/oec/Declare/personal-list',
      export: '/api/oec/Export/OecDeclareHistoryExport',
      exportMulti: '/api/oec/Export/OecDeclareHistoryMultiExport',
      exportResult: '/api/oec/Export/ExportOecDeclare',
      analyzeNum: '/api/oec/Declare/analyzeNum',
      oecconfirm: '/api/oec/Declare/oecconfirm',
      confirm: '/api/oec/Declare/confirm',
      listTree: '/api/oec/Declare/listTree',
      listQuery: '/api/oec/Declare/listQuery',
      commitOecTip: '/api/oec/Declare/CommitOecDeclareValidationAsync',
      commitOec: '/api/oec/Declare/commitOec',
      getPersonnelAuthorization: '/api/oec/PersonnelAuthorization/GetPersonnelAuthorization',
      commitAllOec: 'api/oec/Declare/CommitAllOecDeclareAsync',
      updateOECAsync: '/api/oec/Declare/UpdateOECAsync',
      updateStatus: '/api/oec/Declare/updateStatus',
      rateSum: '/api/oec/Declare/currRateSum',
      revert: '/api/oec/Withdraw/WithdrawOECCommit',
      OecDeclareHistoryWindow: '/api/oec/Declare/OecDeclareHistoryWindow',

      amendmentList: '/api/oec/OecResultAmendment/list',
      isAmendment: '/api/oec/OecResultAmendment/IsAmendment',
      amendmentSave: '/api/oec/OecResultAmendment/Save',
      amendmentCommit: '/api/oec/OecResultAmendment/commit',
      amendmentUpdateStatus: '/api/oec/OecResultAmendment/updateStatus',
      amendmentSaveInfo: '/api/oec/OecResultAmendment/SaveInfo',
      amendmentRevert: '/api/oec/Withdraw/WithdrawOECAmendmentCommit',
      amendmentDelete: '/api/oec/OecResultAmendment/DelInfo',
    },
    publish: {
      list: '/api/oec/Declare/listForOpen',
      confirmOecTip: '/api/oec/Declare/ConfirmAllOecDeclareWarnAsync',
      confirmOec: '/api/oec/Declare/ConfirmAllOecDeclareAsync',
      import: '/api/oec/Declare/ImportConfirmOecAsync',

      declareRemind: '/api/oec/Declare/OECDeclareRemind',
      confirmRemind: '/api/oec/Declare/ConfirmRemind',
      getApproveRemind: '/api/oec/Declare/OECApprovalRemind',
      approveRemind: '/api/oec/Declare/ApprovalRemind',
    },
    executeForm: {
      list: '/api/oec/ExecuteForm/list',
      Remind: '/api/oec/ExecuteForm/Remind',
      GetExecuteFormTbYearList: '/api/oec/ExecuteForm/GetExecuteFormTbYearList',
      GetExecuteFormMonthWorkList: '/api/oec/ExecuteForm/GetExecuteFormMonthWorkList',
      GetExecuteFormWeekWorkList: '/api/oec/ExecuteForm/GetExecuteFormWeekWorkList',
      GetExecuteFormDayWorkList: '/api/oec/ExecuteForm/GetExecuteFormDayWorkList',
      getItem:'/api/oec/ExecuteForm/getItem',
      msgExecuteFormList: '/api/oec/UserInfo/GetSubExecuteFormList',
      getSubExecuteForm: '/api/oec/UserInfo/GetSubExecuteForm',
    },
    declarePermission: {
      list: '/api/oec/DeclarePermission/list',
      edit: '/api/oec/DeclarePermission/CreateOrUpdate',
      del: '/api/oec/DeclarePermission/Delete',
    },
    task: {
      list: '/api/autobio/scheduler-task',
      resume: '/api/autobio/scheduler-task/resume',
      pause: '/api/autobio/scheduler-task/pause',
      trigger: '/api/autobio/scheduler-task/trigger',
    },
    exportTask: {
      list: '/api/oec/ExportTask/List',
    },
    reportStatistics: {
      permissionList: '/api/oec/PeriodResult/GetPermissionList',
      permissionExport: '/api/oec/Export/PermissionListExportByteAsync',
      yearList: '/api/oec/PeriodResult/GetYearInfoList',
      yearExport: '/api/oec/Export/YearInfoListExportByteAsync',
      monthList: '/api/oec/PeriodResult/GetMonthInfoList',
      monthExport: '/api/oec/Export/MonthInfoListExportByteAsync',
      weekList: '/api/oec/PeriodResult/GetWeekInfoList',
      weekExport: '/api/oec/Export/WeekInfoListExportByteAsync',
      dayList: '/api/oec/PeriodResult/GetDayInfoList',
      dayExport: '/api/oec/Export/DayInfoListExportByteAsync',
    },
    remindHistory: {
      list: '/api/oec/RemindHistory/GetList'
    },
    recommendDeclare: {
      list: '/api/oec/OecRecommend/list',
      commit: '/api/oec/OecRecommend/commit',
      historyList: '/api/oec/OecRecommend/historyList',
      update: '/api/oec/OecRecommend/update',
      exportList: '/api/oec/Export/OecRecommendExport',
      exportHistory: '/api/oec/Export/OecRecommendHistoryExport',
      batchExport: '/api/oec/Export/OecRecommendHistoryExportBatchTaskAsync',
      importFile: '/api/oec/OecRecommend/import'
    },
    recommendManage: {
      list: '/api/oec/OecRecommend/manageList',
      update: '/api/oec/OecRecommend/manageUpdate',
      remind: '/api/oec/OecRecommend/OecRecommendRemind',
      remindConfirm: '/api/oec/OecRecommend/OecRecommendRemindConfirm',
      exportFile: '/api/oec/Export/OecRecommManageExport',
      batchExportTask: '/api/oec/Export/OecRecommManageExportBatchTask',
      resultPush: '/api/oec/OecRecommend/OECRecommendResultRemindConfirm',
    },
  },
  export: {
    //个人oec导出
    oec: '/api/oec/Export/OecDeclareResultExport',
    //用户信息导出
    user: '/api/oec/Export/SysUserInfoListExport',
    //年计划详情导出
    yearPlan: '/api/oec/Export/TbYearPlanDetailExport',
    //管理人员执行表格导出任务
    executeFormListTaskExport: '/api/oec/Export/ExecuteFormListTaskExport',
    //年计划详情导出任务
    TbYearPlanDetailTaskExport: '/api/oec/Export/TbYearPlanDetailTaskExport',
    //月计划详情导出任务
    MonthWorkDetailTaskExport: '/api/oec/Export/MonthWorkDetailTaskExport',
    //周计划详情导出任务
    WeekWorkDetailTaskExport: '/api/oec/Export/WeekWorkDetailTaskExport',
    //日计划详情导出任务
    DayWorkDetailTaskExport: '/api/oec/Export/DayWorkDetailTaskExport',
    //OEC管理导出任务
    OecManagementListExport: '/api/oec/Export/OecManagementListExport',
    OecManagementListMultiExport: '/api/oec/Export/OecManagementListMultiExport',    
    exportAccuYear: '/api/oec/Export/ExportAccuYear',
    exportAccuMonthWork: '/api/oec/Export/ExportAccuMonthWork',
    exportAccuWeekWork: '/api/oec/Export/ExportAccuWeekWork',
    //重要度排序配置导出
    ImportantSortConfigExportByteAsync:'/api/oec/Export/ImportantSortConfigExportByteAsync',
    // 消息提醒 直属下级未执行表格 未完成半年总结
    exportSubListInfoByte:'/api/oec/Export/GetSubListInfoByte',
    exportSubHalfListInfoByte:'/api/oec/Export/GetSubHalfListInfoByte',
  },
  transfer: {
    planTransfer: '/api/oec/PlanTransFer/PlanTransFer',
    weekTransfer: '/api/oec/PlanTransfer/WeekWorkPlanTransferApprove',
    monthTransfer: '/api/oec/PlanTransfer/MonthWorkPlanTransferApprove',
    yearTransfer: '/api/oec/PlanTransfer/YearPlanTransferApprove',
    weekHandover: '/api/oec/PlanTransfer/WeekWorkPlanHandoverApprove',
    monthHandover: '/api/oec/PlanTransfer/MonthWorkPlanHandoverApprove',
    yearHandover: '/api/oec/PlanTransfer/YearPlanHandoverApprove',
    yearClassifyNext: '/api/oec/PlanTransfer/GetVersionWorkClassify',

    getMonthWorkClassifyCount: '/api/oec/MonthWorkDetail/GetWorkClassifyCount',
    getWeekWorkClassifyCount: '/api/oec/WeekWorkDetail/GetWorkClassifyCount',
  },
  allCustomList: '/api/oec/CustomSetting/GetAllList',
  withdraw: {
    list: '/api/oec/Withdraw/list',
    revert: '/api/oec/Withdraw/WithdrawItem',
  },
  userAuth: {
    list: '/api/oec/PersonnelAuthorization/List',
    add: '/api/oec/PersonnelAuthorization/Create',
    detail: '/api/oec/PersonnelAuthorization/',
    update: '/api/oec/PersonnelAuthorization/Update',
  },
  editGrants: {
    list: '/api/oec/editGrants/List',
    add: '/api/oec/editGrants/Create',
    detail: '/api/oec/editGrants/',
    update: '/api/oec/editGrants/Update',
  },
  timeGrants: {
    list: '/api/oec/TimeGrants/List',
    add: '/api/oec/TimeGrants/Create',
    detail: '/api/oec/TimeGrants/',
    update: '/api/oec/TimeGrants/Update',
  },
  workManage: {
    list: '/api/oec/workManage/list',
    patch: '/api/oec/WorkManage/Patch',
    year: {
      list: '/api/oec/workManage/ListYear',
      updateDetail: '/api/oec/WorkManage/UpdateYearDetail',
      delete: '/api/oec/WorkManage/DeleteYearDetail',
      deleteList: '/api/oec/WorkManage/DeleteYear'
    },
    month: {
      list: '/api/oec/workManage/ListMonth',
      updateDetail: '/api/oec/WorkManage/UpdateMonthDetail',
      delete: '/api/oec/WorkManage/DeleteMonthDetail',
      deleteList: '/api/oec/WorkManage/DeleteMonth'
    },
    week: {
      list: '/api/oec/workManage/ListWeek',
      updateDetail: '/api/oec/WorkManage/UpdateWeekDetail',
      delete: '/api/oec/WorkManage/DeleteWeekDetail',
      deleteList: '/api/oec/WorkManage/DeleteWeek'
    },
    day: {
      list: '/api/oec/workManage/ListDay',
      updateDetail: '/api/oec/WorkManage/UpdateDayDetail',
      updateSum: '/api/oec/WorkManage/UpdateDay',
      updatePlan: '/api/oec/WorkManage/UpdateDayPlan',
      delete: '/api/oec/WorkManage/DeleteDayDetail',
      deleteList: '/api/oec/WorkManage/DeleteDay',
      deletePlan: '/api/oec/WorkManage/DeleteDayPlan',

    },
  },
  period: {
    importanceSort: {
      list: '/api/oec/ImportantSort/list',
      submit: '/api/oec/ImportantSort/SubmitData',
      search: '/api/oec/ImportantSort/sort-list',
      save: '/api/oec/ImportanceScore/save',
      updateStatus: '/api/oec/ImportantSort/UpdateStatus',
      revert: '/api/oec/Withdraw/WithdrawImportantSortCommit',

      recalc: '/api/oec/ImportantSort/RecalculateScore',
      export: '/api/oec/Export/ImportantSortQueryListExportByteAsync',
    },
    importanceFactor: {
      list: '/api/oec/ImportanceFactor/list',
      update: '/api/oec/ImportanceFactor/Create',
      column: '/api/oec/ImportanceFactor/importance-list',
      delete: '/api/oec/ImportanceFactor',
    },
    importanceSearch: {
      export: '/api/oec/Export/ImportantSortListExport',
      batchExport: '/api/oec/Export/ImportantSortListBatchExportByteAsync',
    },
    resultDeclare: {
      list: '/api/oec/PeriodResult/List',
      rate: '/api/oec/PeriodResult/PeriodRate',
      update: '/api/oec/PeriodResult/Update',
      updateScore: '/api/oec/PeriodResult/UpdateClassifyScore',
      commit: '/api/oec/PeriodResult/Commit',
      updateStatus: '/api/oec/PeriodResult/UpdateStatus',
      revert: '/api/oec/Withdraw/WithdrawPeriodCommit',
      search: '/api/oec/PeriodResult/HistoryList',
      searchRate: '/api/oec/PeriodResult/HistoryRate',

      updateMultiYearScore: '/api/oec/YearItemScore/UpdateClassifyWorkScore',

      exportDeclare: '/api/oec/Export/ListPeriodResultExport',
      export: '/api/oec/Export/PeriodResultHistoryListExport',
      batchExport: '/api/oec/Export/PeriodResultHistoryListBatchExport',
      taskExport: '/api/oec/Export/PeriodResultHistoryDetailListTaskExport',
    },
    workScore: {
      list: '/api/oec/WorkScore/List',
      create: '/api/oec/WorkScore/Create',
      delete: '/api/oec/WorkScore',
      detailList: '/api/oec/WorkScore/ListItemScore',
      addOrUpdate: '/api/oec/WorkScore/CreateOrUpdateMany',
      deleteItem: '/api/oec/WorkScore/DeleteItem',
      selfUpdate: '/api/oec/WorkScore/SelfUpdate',
      submit: '/api/oec/WorkScore/CommitWork',
      updateStatus: '/api/oec/WorkScore/UpdateStatus',
      export: '/api/oec/Export/WorkScoreExport',
      selfExport: '/api/oec/Export/WorkScoreSelfExport',
      taskExport: '/api/oec/Export/PeriodResultScoreDetailListTaskExport',

      growUpUpdateClassify: '/api/oec/WorkScore/UpdateClassify',
      growUpUpdate: '/api/oec/WorkScore/SupUpdate',
      growUpConfirm: '/api/oec/WorkScore/SupConfirm',

      scoreList: '/api/oec/WorkScore/ListScore',
      scoreListExport: '/api/oec/Export/ListScoreExport',

      yearScore: '/api/oec/YearScore/Create',
      yearScoreList: '/api/oec/YearItemScore/GetList',
      yearScoreUpdate: '/api/oec/YearItemScore/UpdateManyWorkScore',
      deleteYearScore: '/api/oec/YearScore/Delete',
      updateYearScore: '/api/oec/YearItemScore/UpdateClassifyAsync',

      yearScoreConfirm: '/api/oec/YearItemScore/Confirm',
      yearExport: '/api/oec/Export/YearScoreExport',
      selfYearExport: '/api/oec/Export/YearScoreSelfExport',

      canJump: '/api/oec/YearScore/CanScore',
    },
    oecWorkScore: {
      list: '/api/oec/PeriodResult/GetPerformanceList',
      export: '/api/oec/Export/PerformanceListExport'
    },
    manage: {
      list: '/api/oec/PeriodResult/GetPerformanceManageList',
      update: '/api/oec/PeriodResult/UpdatePerformanceManage',
      tip: '/api/oec/PeriodResult/ConfirmPerformanceManageWarn',
      confirmTip: '/api/oec/PeriodResult/ConfirmPerformanceManage',
      importTip: '/api/oec/PeriodResult/ImportPerformanceManage',
      importComment: '/api/oec/PeriodResult/ImportPerformanceIsrating',

      importanceData: '/api/oec/ImportantSort/GetImportantSortDetail',
      importanceUpdate: '/api/oec/ImportantSort/UpdateImportantSort',

      listDelete: '/api/oec/WorkScore/DeleteWorkScore',
      deleteItem: '/api/oec/WorkScore/DeleteItemWorkScore',

      addOrUpdate: '/api/oec/WorkScore/CreateOrUpdateManyWorkItemScore',
      selfUpdate: '/api/oec/WorkScore/SelfUpdateWorkScore',
      growUpUpdateClassify: '/api/oec/WorkScore/UpdateClassifyWorkScore',
      growUpUpdate: '/api/oec/WorkScore/SupUpdateWorkScore',

      export: '/api/oec/Export/PeriodResultPerformanceManageListExport',
      exportTaskApi: '/api/oec/Export/PeriodResultManageListTaskExport',
      batchExport: '/api/oec/Export/PeriodResultPerformanceManageListBatchExport',
      batchExportTask: '/api/oec/Export/PeriodResultPerformanceManageBatchTaskExport',

      importOutterData: '/api/oec/PeriodResult/ImportOutterConfirmAsync',
      updateYearWorkItem: '/api/oec/YearItemScore/UpdateWorkItemAsync',
      updateYearScore: '/api/oec/YearItemScore/UpdateClassifyYearScoreAsync',
      deleteYearScore: '/api/oec/YearItemScore/DeleteYearScoreAsync',
      deleteYearScoreItem: '/api/oec/YearItemScore/DeleteYearItemScoreAsync',

      taskExport: '/api/oec/Export/PeriodResultPerformanceManageTaskExport',
      importantSortExport: '/api/oec/Export/PerformanceImportantSortListExportByteAsync',
      
      getCommitList: '/api/oec/PeriodResult/GetCommitList',
      commitRemind: '/api/oec/PeriodResult/CommitRemind',
      
      getApprovalList: '/api/oec/PeriodResult/GetApprovalList',
      approvalRemind: '/api/oec/PeriodResult/ApprovalRemind',

      getPersonCommitList: '/api/oec/PeriodResult/GetPersonCommitList',
      personCommitRemind: '/api/oec/PeriodResult/PersonCommitRemind',
      
      getPersonConfirmList: '/api/oec/PeriodResult/GetPersonConfirmList',
      personConfirmRemind: '/api/oec/PeriodResult/PersonConfirmRemind',
    },
    yearWeight: {
      list: '/api/oec/PeriodClassifyWeight/GetList',
      add: '/api/oec/PeriodClassifyWeight/AddClassify',
      edit: '/api/oec/PeriodClassifyWeight/UpdateClassify',
      'delete': '/api/oec/PeriodClassifyWeight/DeleteClassify',
      importExcel: '/api/oec/PeriodClassifyWeight/ImportClassifyWeight',
      exportExcel: '/api/oec/export/YearClassifyWeightListExportByte',
      getClassify: '/api/oec/PeriodClassifyWeight/GetClassifyByYearPeriod',
      updateBaseWorkClassifyWeight: '/api/oec/PeriodClassifyWeight/UpdateClassifyForDynamic',
    },
    ImportantSortConfig:{
      GetList:'/api/oec/ImportantSortConfig/GetList',
      AddImportantSortConfig:'/api/oec/ImportantSortConfig/AddImportantSortConfig',
      UpdateImportantSortConfig:'/api/oec/ImportantSortConfig/UpdateImportantSortConfig',
      DeleteImportantSortConfig:'/api/oec/ImportantSortConfig/DeleteImportantSortConfig',
      ImportImportantSortConfig:'/api/oec/ImportantSortConfig/ImportImportantSortConfig',
    },
    importanceSortManage:{
      GetImportanceManageListAsync:'/api/oec/ImportantSort/GetImportanceManageListAsync',
      ImportanceManageListExport:'/api/oec/Export/ImportanceManageListExport',
      ImportanceManageListBatchTaskExport:'/api/oec/Export/ImportanceManageListBatchTaskExport',

      getBuiltInFactor: '/api/oec/ImportanceFactor/GetBuiltInList',
      deleteBuiltInFactor: '/api/oec/ImportanceFactor/DeleteBuiltInFactor',
      updateBuiltInFactor: '/api/oec/ImportanceFactor/AddOrUpdateBuiltInFactor',
      
      getCommitList: '/api/oec/ImportantSort/GetCommitList',
      commitRemind: '/api/oec/ImportantSort/CommitRemind',
      getApprovalList: '/api/oec/ImportantSort/GetApprovalList',
      approvalRemind: '/api/oec/ImportantSort/ApprovalRemind',
    },
  },
  todoWork: {
    list: '/api/oec/TodoWork/GetList',
    add: '/api/oec/TodoWork/Create',
    update: '/api/oec/TodoWork/Update',
    del: '/api/oec/TodoWork/Delete',
    publish: '/api/oec/TodoWork/Publish',
    approveInfo: '/api/oec/TodoWork/GetCommittedInfo',
    updateStatus: '/api/oec/TodoWork/UpdateStatus',
    getDetail: '/api/oec/TodoWork/GetWorkDetail',
  },
  recommendedConfig: {
    list: '/api/oec/OecRecommConfig/list',
    add: '/api/oec/OecRecommConfig/Create',
    update: '/api/oec/OecRecommConfig/Update',
    del: '/api/oec/OecRecommConfig/Delete',
    exportFile: '/api/oec/Export/OecRecommConfigExportByte',
    importFile: '/api/oec/OecRecommConfig/ImportOECRecommConfig',
  },
  responsWork: {
    personal: {
      add: '/api/oec/ResponseWork/Create',
      supply: '/api/oec/ResponseWork/SupplyCreate',
      update: '/api/oec/ResponseWork/UpdateCreate',
      list: '/api/oec/ResponseWork/GetList',
      del: '/api/oec/ResponseWork/Delete',
    },
    detail: {
      getWorkDetail: '/api/oec/ResponseWork/GetWorkDetail',
      update: '/api/oec/ResponseWork/Update',
      updateItem: '/api/oec/ResponseWork/UpdateDetail',
      detailItem: '/api/oec/ResponseWork/DeleteDetail',
      commit: '/api/oec/ResponseWork/Commit',
      updateStatus: '/api/oec/ResponseWork/UpdateStatus',
      exportFile: '/api/oec/ResponseWork/ExportWork',
    },
    history: {
      list: '/api/oec/ResponseQuery/GetList',
      detailList: '/api/oec/ResponseQuery/GetListByWkno',
      exportTask: '/api/oec/Export/ResponseQueryTaskExport',
      confirm: '/api/oec/ResponseQuery/Confirm',
    },
    manage: {
      list: '/api/oec/ResponseManage/GetList',
      declareList: '/api/oec/ResponseManage/GetConfirmList',
      declareConfirm: '/api/oec/ResponseManage/ConfirmRemind',
      approvalList: '/api/oec/ResponseManage/GetApprovalList',
      approvalConfirm: '/api/oec/ResponseManage/ApprovalRemind',
      batchExportStatus: '/api/oec/Export/ResponseListExportBatch',
      batchExportExcel: '/api/oec/Export/ResponseListDetailExportBatch',
      deleteResponse: '/api/oec/ResponseManage/Delete',
      deleteResponseDetail: '/api/oec/ResponseManage/DeleteDetail',
      detailSave: '/api/oec/ResponseManage/UpdateResponse',
      importNotInvolved: '/api/oec/ResponseManage/ImportNotInvolved',
    }
  },
  userLogin(objParam) {
      console.log(objParam);
    let strParams = qs.stringify(objParam);
    return ajax.http({
      baseURL: "http://192.168.34.241:53978",
      headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
      url: '/connect/token',
      method: 'post',
      data: strParams,
    });
  },
};
